// frontend/src/components/Layout/Footer.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  
  // Define Tailwind classes
  const linkClass = "text-gray-200 hover:text-orange-500 font-extrabold transition-colors";
  
  return (
    <footer className="bg-brand-dark border-t-2 border-slate-700 w-full py-3">
      <div className="container mx-auto px-4">
        
        <div className="flex justify-center items-center flex-wrap gap-4 text-sm">
          
          {/* Legal Section - Now much simpler! */}
          <div className="flex gap-6">
            <Link 
              to="/impressum" // ✅ The path is now static and clean
              className={linkClass}
            >
              {t('imprint')} {/* ✅ The text comes directly from i18next */}
            </Link>
            <Link to="/terms" className={linkClass}>
                {t('terms_of_service')}
            </Link>
            <Link to="/privacy" className={linkClass}>
                {t('privacy_policy')}
            </Link>
          </div>

          {/* Copyright/Trademark Section */}
          <div className="text-gray-400">
             © {new Date().getFullYear()} ugotai
          </div>
          
          {/* Social Icons Section */}
          <div className="footer-section social-icons">
            {/* LinkedIn */}
            <a 
              href="https://linkedin.com/company/caaise" 
              target="_blank" 
              rel="noopener noreferrer" 
              title="LinkedIn"
              className={linkClass + " ml-4"} // Note: You might want a gap class on the parent instead
            >
              <i className="fab fa-linkedin"></i> LinkedIn 
            </a>
            
            {/* YouTube */}
            <a 
              href="https://youtube.com/@caaise-o4f?si=7uehsmWe3_GtSb44" 
              target="_blank" 
              rel="noopener noreferrer" 
              title="YouTube"
              className={linkClass}
            >
              <i className="fab fa-youtube"></i> YouTube
            </a>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
